<template>
  <div class="liveCategory__categoryItem" :data-category-id="category.id">
    <div
      class="categoryItem__img"
      :style="{
        width: `${imageWidth}px`,
      }"
    >
      <PrettyImage
        :src="category.imageUrl ? category.imageUrl : NO_IMAGE"
      ></PrettyImage>
    </div>
    <div
      class="categoryItem__info"
      :class="{
        'categoryItem__info--header': header,
      }"
    >
      <template class="" v-if="header">
        <table>
          <tbody>
            <tr>
              <td>专题名称</td>
              <td>
                <div
                  style="display: inline-flex; align-items: flex-start; gap: 5px"
                >
                  <span>{{ category.name }}</span>
                  <span
                    class="publishStatus__tag"
                    :class="{
                      'publishStatus__tag--publish':
                        category.publishStatus ===
                        Const.LiveCategory.Status.Publish,
                    }"
                  >
                    <PrettyText
                      style="word-break: keep-all"
                      :text="
                        category.publishStatus ===
                        Const.LiveCategory.Status.Publish
                          ? '已发布'
                          : '未发布'
                      "
                    />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>专题 ID：</td>
              <td>{{ category.id }}</td>
            </tr>
            <tr>
              <td>所属用户：</td>
              <td>{{ category.userName }}</td>
            </tr>
            <tr>
              <td>创建时间：</td>
              <td>{{ category.createDatetime }}</td>
            </tr>
            <tr
              v-if="
                category.publishStatus === Const.LiveCategory.Status.Publish
              "
            >
              <td>发布时间：</td>
              <td>{{ category.publishDatetime }}</td>
            </tr>
            <tr>
              <td>简介：</td>
              <td>
                {{ category.description }}
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-else>
        <div class="categoryItem__info__title">
          <RouterLink
            tag="a"
            :to="`/home/live_category/detail/${category.id}`"
            class="titleLink"
          >
            {{ category.name }}
          </RouterLink>
          <span
            class="publishStatus__tag"
            :class="{
              'publishStatus__tag--publish':
                category.publishStatus === Const.LiveCategory.Status.Publish,
            }"
          >
            <PrettyText
              :text="
                category.publishStatus === Const.LiveCategory.Status.Publish
                  ? '已发布'
                  : '未发布'
              "
            />
          </span>
        </div>
        <table>
          <tbody>
            <tr>
              <td>专题 ID：</td>
              <td>{{ category.id }}</td>
            </tr>
            <tr>
              <td>所属用户：</td>
              <td>{{ category.userName }}</td>
            </tr>
            <tr>
              <td>关联直播数：</td>
              <td>{{ category.liveRoomNum }}</td>
            </tr>
          </tbody>
        </table>
      </template>
      <ButtonGroup>
        <Button
          type="dashed"
          :to="`/home/live_category/detail/${category.id}`"
          icon="md-settings"
          v-if="!header"
        >
          详情
        </Button>
        <Button
          type="dashed"
          :to="`/home/live_category/edit/${category.id}`"
          icon="md-create"
        >
          编辑
        </Button>
        <Button
          type="dashed"
          icon="md-share"
          @click="isShowCategoryShareModel = true"
        >
          分享
        </Button>
        <CategoryShareModal
          v-model="isShowCategoryShareModel"
          :url="category.shareUrl"
        ></CategoryShareModal>
        <Button
          type="dashed"
          icon="md-cloud-upload"
          @click="publish"
          v-if="category.publishStatus === Const.LiveCategory.Status.UnPublish"
        >
          发布
        </Button>
        <Button
          type="dashed"
          icon="md-cloud-upload"
          @click="unPublish"
          v-else-if="
            category.publishStatus === Const.LiveCategory.Status.Publish
          "
        >
          撤回
        </Button>
        <Button type="dashed" icon="md-close" @click="del">删除</Button>
      </ButtonGroup>
    </div>
    <div class="categoryItem__extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script>
import PrettyImage from "@/components/PrettyImage.vue";
import PrettyText from "@/components/PrettyText.vue";
import CategoryShareModal from "@/components/CategoryShareModal.vue";
import NO_IMAGE from "@/assets/noimage2.jpg";
import api from "@/api/Api";
import { Const } from "@/model/ApiModel";
import helper from "@/assets/helper.js";

export default {
  components: {
    PrettyImage,
    PrettyText,
    CategoryShareModal,
  },
  props: {
    category: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    imageWidth: {
      type: [String, Number],
      default: "160",
    },
    header: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowCategoryShareModel: false,
    };
  },
  computed: {
    NO_IMAGE() {
      return NO_IMAGE;
    },
    Const() {
      return Const;
    },
    helper() {
      return helper;
    },
  },
  methods: {
    del() {
      this.$Modal.confirm({
        title: `确认删除`,
        content: `确认删除专题（${this.category.name}）?`,
        loading: true,
        onOk: async () => {
          try {
            await api.call("liveRoomCategory/delete", {
              id: this.category.id,
            });
            this.$emit("deleteSuccess");
          } catch (e) {
            console.error(e);
            this.$Notice.error({
              title: this.$t("Message.remove.error"),
              desc: e.resultMsg,
            });
          }
          this.$Modal.remove();
        },
      });
    },
    publish() {
      this.$Modal.confirm({
        title: `确认发布`,
        content: `确认发布专题（${this.category.name}）?`,
        loading: true,
        onOk: async () => {
          try {
            await api.call("liveRoomCategory/publish", {
              id: this.category.id,
              publishStatus: 1,
            });
            this.$emit("publishSuccess");
          } catch (e) {
            console.error(e);
            // this.$Notice.error({
            //   title: "发布专题失败",
            //   desc: e.resultMsg,
            // });
          }
          this.$Modal.remove();
        },
      });
    },
    unPublish() {
      this.$Modal.confirm({
        title: `撤销发布`,
        content: `撤销发布专题（${this.category.name}）?`,
        loading: true,
        onOk: async () => {
          try {
            await api.call("liveRoomCategory/publish", {
              id: this.category.id,
              publishStatus: 0,
            });
            this.$emit("unPublishSuccess");
          } catch (e) {
            console.error(e);
            // this.$Notice.error({
            //   title: "撤销专题失败",
            //   desc: e.resultMsg,
            // });
          }
          this.$Modal.remove();
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.liveCategory__categoryItem {
  display: flex;

  .categoryItem__img {
    flex-shrink: 0;
    width: 160px;

    img {
      display: block;
      width: 100%;
      object-fit: contain;
      border-radius: 5px;
      aspect-ratio: 16 / 9;
    }
  }

  .categoryItem__info {
    margin-left: 20px;

    .publishStatus__tag {
      border-radius: 5px;
      font-size: 12px;
      background: #a8a8a8;
      padding: 2px;
      color: white;

      &.publishStatus__tag--publish {
        background-color: rgb(126, 206, 244);
      }
    }

    &.categoryItem__info--header {
      table {
        max-width: 100%;

        tr {
          font-size: 13px;

          td:nth-child(2n + 1) {
            vertical-align: top;
            white-space: nowrap;
            font-weight: 700;
            color: #666;
            padding: 2px 0;
          }
        }
      }
    }

    .categoryItem__info__title {
      display: flex;
      align-items: center;
      gap: 10px;

      .titleLink {
        font-size: 15px;
      }

      .ivu-tag {
        margin: 0;
      }
    }

    table {
      color: #989898;
      margin: 5px 0;
    }
  }

  .categoryItem__extra {
    flex-shrink: 0;
    margin-left: auto;
  }
}
</style>
